import React, { MouseEvent, useEffect } from "react";
import _ from "lodash";
import { LocaleUtil } from "@eres/core";
import * as SSO from "@10x/sso";
import { getName } from "@10x/sso";
import { getProfilePicUrl } from "@my-dld/utils/PathUtils";
import { emailF, phoneNumber, picCache } from "@my-dld/screens/MyDLD/MyProfile";
import { eidFormat } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";
import { navigate } from "@my-dld/utils/StoreUtils";
import { getLocalValue } from "@eres/core/dist/LocaleValue";
import { TWIMC } from "@my-dld/utils/TabuServices";
import { getVIPCategory } from "@my-dld/utils/User";

function PersonalInfo() {
	useEffect( () => {
		window.addEventListener( "scroll", onScroll );
		return () => {
			window.removeEventListener( "scroll", onScroll );
		};
	}, [] );

	const onScroll = () => {
		// DEVOP-2253 Commit change
		const sidebar = window.$( ".mydld-profile-sidebar" );
		if ( window.scrollY > 175 ) {
			sidebar.addClass( "profile-sidebar-float" );
		} else {
			sidebar.removeClass( "profile-sidebar-float" );
		}
	};

	const onMyProfile = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/profile" );
	};

	const onAccountManager = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/account_manager" );
	};

	const onTWIMC = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/taburequest/twimc" );
	};

	const onMyRequests = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		navigate( "/mydld/my_requests" );
	};

	const onLogout = ( e: MouseEvent<HTMLAnchorElement> ) => {
		e.preventDefault();
		if ( window.showMyDLDLogout )
			window.showMyDLDLogout();
	};

	const name = _.startCase( LocaleUtil.getLocalValue( getName() ).toLowerCase() );
	return <>

        <div className="user-info-d1">
            <div className="user-info-text">
                <img
                    src={getProfilePicUrl(picCache.cacheId)}
                    className="img-fluid" alt="user image" />
                <div className="person-name">
                    <span>{name}</span>
                    <span>{eidFormat(SSO.getEmiratesID())}</span>
                </div>
            </div>
            <div className="person-info-action">
                <a href="#" className="btn btn-grey" onClick={onMyProfile}>
                    <i className="material-icons-outlined">visibility</i> {Strings.my_profile}
                </a>
                {getVIPCategory() && <>
                    <a href="#" className="btn btn-grey" onClick={onAccountManager}>
                        {Strings.contact_your_account_manager}
                    </a>
                </>}
                <a href="#" className="btn btn-grey" onClick={onLogout}>
                    <i className="material-icons-outlined">logout</i> {Strings.sign_out}
                </a>
            </div>
        </div>
		<div className="user-info-div hide">
			<div>
				<div className="fw-bold mb-2"></div>
				<div className="dd-user-info">
					<div>
						<span>{ Strings.email }</span>
						<span>{ emailF() }</span>
					</div>
					<div>
						<span>{ Strings.phone }</span>
						<span>{ phoneNumber() }</span>
					</div>
					<div>
						<span>{ Strings.emirates_id }</span>
						<span></span>
					</div>
				</div>
			</div>
			

		</div>


		{/*<div className="mydld-profile-sidebar">
			<label className="btn btn-grey profile-panel-btn" htmlFor="btnradio1">{ Strings.view_details }</label>
			<input type="checkbox" className="btn-check hide" name="btncheckbox" id="btnradio1"/>
			<div className="profile-sidebar-body">
				<ul className="profile-info-list list-group list-group-flush">

					<li className="list-group-item list-group-item-action">
						<a href="#" onClick={ onTWIMC }>
							<i className="icon-to-whom-concern-new"/>
							{ getLocalValue( TWIMC.Name ) }
							<i className="fa fa-angle-right"/>
						</a>
					</li>
					<li className="list-group-item list-group-item-action">
						<a href="#" onClick={ onMyRequests }>
							<i className="icon-my-request-new"/>
							{ Strings.my_requests }
							<i className="fa fa-angle-right"/>
						</a>
					</li>
				</ul>
			</div>
		</div>*/}
	</>;

}

export default PersonalInfo;
